<script lang="ts">
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";
  import { isKeg, soldInCases, soldInUnits } from "@shared/svelte/ProductHelpers.js";
  import { InventoryItemStore } from "@retailer/svelte/CartWidget/v2/Stores/InventoryItemStore";

  import type { Discount } from "@shared/types/Deals";

  export let discount: Discount;
  export let getUnitPrice: (product: Discount) => number;
  export let inventoryId: number;

  function getDealUnitPrice(discount) {
    if (!discount.case_price) {
      return;
    }
    return getUnitPrice(discount) - getDealUnitDiscountAmount(discount);
  }

  function getDealUnitDiscountAmount(discount) {
    return discount && discount.discount_per_unit;
  }

  function getDealCasePrice(discount) {
    if (!discount.case_price) {
      return;
    }
    return discount.case_price - (getDealCaseDiscountAmount(discount) || 0);
  }

  function getDealCaseDiscountAmount(discount) {
    if (discount.discount_amount && discount.discount_unit_label == "case") {
      return discount.discount_amount;
    }
    if (discount.container_case_size) {
      return discount.discount_per_unit * discount.container_case_size;
    }
  }

  $: inventoryItemSoldBy = $InventoryItemStore?.inventoryItems[inventoryId]?.sold_by;
</script>

<div>
  {#if ((soldInUnits(discount, discount, inventoryItemSoldBy) && !soldInCases(discount, discount, inventoryItemSoldBy)) || isKeg(discount) || discount.unit_type == "units") && getDealUnitPrice(discount)}
    <FormatMoney input={getDealUnitPrice(discount)} />/{discount.container_type}
    {#if getDealUnitDiscountAmount(discount)}
      <span class="fizz-text-small fizz-text-deal fizz-nowrap">
        <s class="fizz-text-subdued">
          <FormatMoney input={getUnitPrice(discount)} />
        </s>
        (<FormatMoney input={getDealUnitDiscountAmount(discount)} /> off)
      </span>
    {/if}
  {:else if soldInCases(discount, discount, inventoryItemSoldBy) && getDealCasePrice(discount)}
    <FormatMoney input={getDealCasePrice(discount)} />/case
    {#if getDealCaseDiscountAmount(discount)}
      <span class="fizz-text-small fizz-text-deal fizz-nowrap">
        <s class="fizz-text-subdued">
          <FormatMoney input={discount.case_price} />
        </s>
        (<FormatMoney input={getDealCaseDiscountAmount(discount)} /> off)
      </span>
    {/if}

    {#if getDealUnitPrice(discount) && getUnitPrice(discount)}
      <br />
      <span class="fizz-text-small fizz-text-subdued">
        <FormatMoney input={getDealUnitPrice(discount)} />/{discount.container_type}
      </span>
    {/if}
  {/if}
</div>
